export default __webpack_public_path__ + "static/media/Alpha.d39b03cb.webp";